import React from "react";

const ProjectInformationView = () => {
  return <>Project Information</>;
};

export default ProjectInformationView;